import axios from "axios";

export default {
    /**
     * 
     * @param {Obejct} obj 
     * @param {String} obj.type 
     * @param {String} obj.studyId 
     * @param {String} obj.episodeId
     */
    getXyShare(obj) {
        return axios.post("/course/Html/getShareInfo", obj);
    },
    addShareLog(obj) {
        return axios.post(`/home/Market/addShareLog`, obj);
    }
}